/* created by Athukorala */

import * as actionTypes from '../Action/actionTypes';

const initialState = {
  isAnimation: false //default --> false
};

const reducer=(state=initialState,action)=>{
  switch(action.type){


    case actionTypes.ANIMATION:
      return {
        ...state,
        isAnimation: action.value
      };

    default:
      return state;
  }
};

export default reducer;
